module.exports = __webpack_public_path__ + "static/Icons_House_inactive-2805f1195c0cbf3e12293f121eaf42a0.png";